module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp13_7042.52809034.png";